export default __webpack_public_path__ + "static/media/actividad-28.290e15e8.mp3";